import { render, staticRenderFns } from "./ArchivedMission.vue?vue&type=template&id=5901c4f8&"
import script from "./ArchivedMission.vue?vue&type=script&lang=js&"
export * from "./ArchivedMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports